<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Crear campo de búsqueda</h6>
    <form class="needs-validation" id="formCreateSearchableAtribute"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre identificatorio del campo"
                      name="nombre identificatorio"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre identificatorio')"
                      v-validate="'required'"
                      v-model="model.name">
          </base-input>
        </div>
        
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre público del campo"
                      name="nombre publico"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre publico')"
                      v-validate="'required'"
                      v-model="model.name_public">
          </base-input>
        </div>
        
      </div>
      <div class="form-row">
          <div class="col-md-6">
                <base-input label="Tipo de campo">
                    <el-select @change="cambiaTipoCampo"  v-model="model.att_type" filterable
                                placeholder="Seleccione tipo de campo">
                        <el-option v-for="option in selectTiposCampos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
          <div class="col-md-6">
                <base-input label="Tipo de dato">
                    <el-select  v-model="model.data_type_input" filterable
                                placeholder="Seleccione tipo de campo">
                        <el-option v-for="option in selectTiposDatos"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row" v-if="model.att_type == 'ENUM'">
          <div class="col-md-12">
                <base-input label="Ingrese opciones disponibles para este campo:">
                    <tags-input  v-model="model.choices" placeholder="Agregar una opcion..." class=""></tags-input>
                </base-input>
          </div>
      </div>
      <card v-if="model.att_type == 'ENUM'">
          <h5 slot="header" class="h4 card-title mb-0">Simulación del campo:</h5>
          <div class="row">
            
            <base-input :label="'Ingrese '+model.name_public+':'">
                <el-select  v-model="ejemploOpciones" filterable
                            :placeholder="'Seleccione '+model.name_public+':'">
                    <el-option v-for="option in model.choices"
                                :key="option.label"
                                :label="option.label"
                                :value="option.value">
                    </el-option>
                </el-select>
            </base-input>
            
          </div>
      </card>
      <card v-if="model.att_type == 'RANGE' || model.att_type == 'VARIABLE'" >
          <h5 slot="header" class="h4 card-title mb-0">Simulación del campo:</h5>
          <div class="container">
          <div class="row">
            <base-input :label="'Ingrese '+model.name_public+':'"
                      :placeholder="'Ingrese '+model.name_public"
                      >
            </base-input>
          </div>
          </div>
      </card>
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formCreateSearchableAtribute">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
  import BaseTable from '@/components/BaseTable';
  import TagsInput from '@/components/Inputs/TagsInput';
  import { Select, Option } from 'element-ui';
  export default {
    components: {
        BaseTable,
        [Select.name]: Select,
        [Option.name]: Option,
        TagsInput
    },
    data() {
      return {
        validated: false,
        model: {
          name: '',
          att_type: '',
          choices: [],
          name_public: '',
          data_type_input: ''
        },
        ejemploOpciones: '',
        showModal: false,
        selectTiposCampos: [
          { label: 'Campo filtro de Opciones', value: 'ENUM' },
          { label: 'Campo filtro rango de valores numéricos', value: 'RANGE' },
          { label: 'Campo de datos cálculo Pricing', value: 'VARIABLE' } 
        ],
        selectTiposDatos: [
          { label: 'Numérico Entero', value: 'int' },
          { label: 'Numérico con Decimales', value: 'float' },
          { label: 'Alfanumérico', value: 'string' } 
        ],
        features: [
          /*
          {
            campo: 'Email Forwarding',
            tipo_campo: '<i class="fas fa-check text-success"></i>',
            tipo_dato: '<i class="fas fa-check text-success"></i>'
          },
          */
        ]
      }
    },
    methods: {
      fetchData(){
          console.log('se activa el metodo fetchData');
      },
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },

    },
    created()
    {
      this.$parent.$on('showModalAppendSearchableAtribute', () => { this.showModal = true; this.fetchData(); } )
    },
    
  }
</script>
<style>
</style>
